import React, { Suspense } from 'react';

const LazyUniqueSystemDialog = React.lazy(
  () => import(
    /* webpackChunkName: "page_dialogs" */
    './uniqueDialog/sytstem'
  ),
);
const LazyUniqueDialogs = React.lazy(
  () => import(
    /* webpackChunkName: "page_dialogs" */
    './uniqueDialog/dialogs'
  ),
);
export const UniqueDialogs: React.FC<any> = (props) => (
  <Suspense weId={`${props.weId || ''}_phur2m`} fallback={<div />}>
    <LazyUniqueDialogs weId={`${props.weId || ''}_lpc0vf`} {...props} />
  </Suspense>
);

export const UniqueSystemDialog: React.FC<any> = (props) => (
  <Suspense weId={`${props.weId || ''}_phur2m`} fallback={<div />}>
    <LazyUniqueSystemDialog weId={`${props.weId || ''}_lpc0vf`} {...props} />
  </Suspense>
);

export default {};
